function isMobile() {
	return /Android|webOS|ipad|tablet|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isResp() {
  return $(window).innerWidth() < 812;
}

var top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
var scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;

// vars
var scroll;
var sortie_ok, ajax_ok, currentMousePos = { x: window.innerWidth / 2, y: window.innerHeight / 2 },
    ancien_delta, animParallax = false,
    contenu_nouvelle_page, widthToScroll, demiecran, blockLeft, valeurFixetop, lien_en_cours;

if (isMobile() === true) {
    $('body').addClass('is-mobile');
}

$(document).ready(function() { 
    //--------------//
    // PROCESS AJAX //
    //--------------//
    var $main = $("#main"),

        //------------------//
        // AUTRES FONCTIONS //
        //------------------//
        le_raf = function() {
            raf = requestAnimationFrame(le_raf);
    
            var body = document.body, html = document.documentElement;
            var startPxToScroll = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);;
            var endtoTop = startPxToScroll - window.scrollY;

            var doisscroll = $("#main").width() - $(window).width();
            var pxScoller = startPxToScroll - endtoTop;
            var heighthwindow = $(window).height();
            var coefmulti = doisscroll / startPxToScroll;
                $(".data-scroll").each(function(index) {
                    var offsetScroll = $(this).attr("data-offset");
                    if ($(this).offset().top < window.innerHeight * offsetScroll && $(this).offset().top + $(this).height() - $(document).scrollTop() > 0) {
                        $(this).addClass('is-inview');
                        $(this).find('.parra').addClass('actif-parra')
                        animParallax = false
                    } else {
                        $(this).find('.parra').removeClass('actif-parra')
                    }
                });
          
          
          if (isMobile() === true || isResp() === true){
    		if($(window).scrollTop() > $('#s0-4').offset().top-80){
              gsap.to('.products-menu', { opacity: 1, duration: .2 });
  			}
            else{
              gsap.to('.products-menu', { opacity: 0, duration: .2 });
            }

          }
          
          else if (isMobile() === false || isResp() === false) {

                if ($('.data-scroll').hasClass('is-inview')) {
                    var parent = $('.actif-parra').parent().height();
                    var toMove = $('.actif-parra').height() - window.innerHeight;
                    var pxtoMove = toMove / (window.innerHeight * 2);
                    var offset = $('.actif-parra').offset().top;
                    var f = (offset * pxtoMove) * 1
                    if (animParallax === false) {
                        gsap.to('.actif-parra', { opacity: 1, y: -f, duration: .2 });
                    }
                } else {
                    var f = 0;
                    animParallax = true
                }
            }
            var widthWindow = $(window).width();
            var heighthWindow = $(window).height();
            var widthActus = $("#moveToLeft").width();
            var margeTopActus = $("#moveToLeft").offset().top;
            var widthActusInvisible = widthActus - (widthWindow / 2);
            var coefMoving = widthActusInvisible / (heighthWindow * 0.5);
            var pxToScroll = heighthWindow - margeTopActus;
            var widthActus2 = $("#moveToRight").width();
            var margeTopActus2 = $("#moveToRight").offset().top;
            var widthActus2Invisible = widthActus2 - (widthWindow / 2);
            var pxToScroll2 = heighthWindow - margeTopActus2;
            var coefMoving2 = widthActus2Invisible / (heighthWindow * .8);
            if ($('#s0-2, #s0-3-2').hasClass('is-inview')) {
                if (isMobile() === false || isResp() === false){
                 	gsap.to('#moveToLeft', { x: -(widthWindow / 2) + (pxToScroll * coefMoving), duration: .5 });
                	gsap.to('#moveToRight', { x: (widthWindow / 2) - (pxToScroll2 * coefMoving2), duration: 1 });
                }
              	else{}
            };

        };

    le_raf();


  	gsap.config({ nullTargetWarn: false });
  
  	  
  if (isMobile() === true || isResp() === true){
      function checkElementLocation() {
        var $window = $(window);
        var bottom_of_window = $window.scrollTop() + $window.height();

        $('#s0-2').each(function(i) {
          var $that = $(this);
          var bottom_of_object = $that.position().top + $that.outerHeight();

          //if element is in viewport, add the animate class
          if (bottom_of_window > bottom_of_object) {
            $(this).addClass('fade-in');
          }
        });
      }
      // if in viewport, show the animation
      checkElementLocation();

      $(window).on('scroll', function() {
        checkElementLocation();
      });
  }

}); // end document.ready()